// frontend/src/components/common/StarRating.js
import React from 'react';
import { FaStar } from 'react-icons/fa';

function StarRating({ rating, setRating, readOnly = false, size = 20 }) {
  return (
    <div className="flex">
      {[...Array(5)].map((_, index) => {
        const ratingValue = index + 1;
        return (
          <label key={index} className={readOnly ? "cursor-default" : "cursor-pointer"}>
            {!readOnly && (
              <input
                type="radio"
                name="rating"
                value={ratingValue}
                onClick={() => setRating(ratingValue)}
                className="hidden"
              />
            )}
            <FaStar
              size={size}
              className={`transition-colors ${
                ratingValue <= rating ? "text-yellow-400" : "text-gray-300"
              }`}
            />
          </label>
        );
      })}
    </div>
  );
}

export default StarRating;